import { ref, get, update } from 'firebase/database';
import { db } from '../../../integrations/firebase';

export const fetchProducts = async () => {
    try {
        const snapshot = await get(ref(db, 'products'));
        if (!snapshot.exists()) return {};

        const data = snapshot.val();
        const products = {};

        Object.keys(data).forEach(key => {
            const p = data[key];
            products[key] = {
                ...p,
                id: key, // Store Firebase Key as id
                sku: p.sku || key, // Use User SKU if available, else Key
                // normalize numeric fields
                price: Number(p.priceAfterTax ?? p.priceMRP ?? p.price ?? 0),
                priceMRP: Number(p.priceMRP ?? 0),
                priceAfterTax: Number(p.priceAfterTax ?? p.priceMRP ?? 0),
                priceBeforeTax: Number(p.priceBeforeTax ?? 0),
                costPrice: Number(p.costPrice ?? 0), // Added Cost Price
                hsn: p.hsn || '', // Added HSN
                gstRate: parseFloat(p.gstRate ?? 0) || 0, // Fix: Use parseFloat to handle "5%" strings
                initialStock: Number(p.initialStock ?? 0),
                stock: Number(p.initialStock ?? 0), // Map stock to initialStock for safety
                minStock: Number(p.minStock ?? 0),
                weight_grams: Number(p.weight_grams ?? p.dimensions?.weight_grams ?? 0),
                dimensions: {
                    length: Number(p.dimensions?.length_cm ?? p.length ?? 0),
                    width: Number(p.dimensions?.breadth_cm ?? p.breadth ?? 0),
                    height: Number(p.dimensions?.height_cm ?? p.height ?? 0),
                    unit: 'cm'
                }
            };
        });

        return products;
    } catch (error) {
        console.error("Error fetching products:", error);
        return {};
    }
};

export const restoreOrderStock = async (order) => {
    if (!order || !order.items) return;

    try {
        const updates = {};

        // Loop through each item in the order
        for (const item of order.items) {
            if (item.sku) {
                const productRef = ref(db, `products/${item.sku}`);
                const snapshot = await get(productRef);
                if (snapshot.exists()) {
                    const product = snapshot.val();
                    // Use initialStock as the source of truth for stock as per fetchProducts logic
                    const currentStock = Number(product.initialStock || 0);
                    const quantityToRestore = Number(item.quantity || 0);

                    updates[`products/${item.sku}/initialStock`] = currentStock + quantityToRestore;
                }
            }
        }

        if (Object.keys(updates).length > 0) {
            await update(ref(db), updates);
        }
        console.log("Stock restored for order:", order.id);
    } catch (error) {
        console.error("Failed to restore stock:", error);
        throw error;
    }
};
